/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCareAdmissionCopyFlags } from './MatrixCareAdmissionCopyFlags';
import {
    MatrixCareAdmissionCopyFlagsFromJSON,
    MatrixCareAdmissionCopyFlagsFromJSONTyped,
    MatrixCareAdmissionCopyFlagsToJSON,
    MatrixCareAdmissionCopyFlagsToJSONTyped,
} from './MatrixCareAdmissionCopyFlags';

/**
 * 
 * @export
 * @interface CreateMatrixCareHomeHealthAdmissionRequest
 */
export interface CreateMatrixCareHomeHealthAdmissionRequest {
    /**
     * MatrixCare `PatientDemoId` from the patient-search match for this patient. Required to open the New Admission page.
     * @type {string}
     * @memberof CreateMatrixCareHomeHealthAdmissionRequest
     */
    patient_demo_id: string;
    /**
     * An admission MatrixCare currently offers as a copy source. Verified live before the copy.
     * @type {string}
     * @memberof CreateMatrixCareHomeHealthAdmissionRequest
     */
    source_admission_id: string;
    /**
     * Destination business unit. Verified against the business units available to the credential.
     * @type {string}
     * @memberof CreateMatrixCareHomeHealthAdmissionRequest
     */
    business_unit_id: string;
    /**
     * Destination line of business. Verified against the lines of business MatrixCare returns for the business unit.
     * @type {string}
     * @memberof CreateMatrixCareHomeHealthAdmissionRequest
     */
    line_of_business_id: string;
    /**
     * M/D/YYYY, MatrixCare's browser wire format.
     * @type {string}
     * @memberof CreateMatrixCareHomeHealthAdmissionRequest
     */
    new_referral_date: string;
    /**
     * MatrixCare's benefit/certification period selection. Sent for Hospice lines of business; omitted otherwise.
     * @type {string}
     * @memberof CreateMatrixCareHomeHealthAdmissionRequest
     */
    certification_period_start?: string;
    /**
     * 
     * @type {MatrixCareAdmissionCopyFlags}
     * @memberof CreateMatrixCareHomeHealthAdmissionRequest
     */
    copy_flags: MatrixCareAdmissionCopyFlags;
}

/**
 * Check if a given object implements the CreateMatrixCareHomeHealthAdmissionRequest interface.
 */
export function instanceOfCreateMatrixCareHomeHealthAdmissionRequest(value: object): value is CreateMatrixCareHomeHealthAdmissionRequest {
    if (!('patient_demo_id' in value) || value['patient_demo_id'] === undefined) return false;
    if (!('source_admission_id' in value) || value['source_admission_id'] === undefined) return false;
    if (!('business_unit_id' in value) || value['business_unit_id'] === undefined) return false;
    if (!('line_of_business_id' in value) || value['line_of_business_id'] === undefined) return false;
    if (!('new_referral_date' in value) || value['new_referral_date'] === undefined) return false;
    if (!('copy_flags' in value) || value['copy_flags'] === undefined) return false;
    return true;
}

export function CreateMatrixCareHomeHealthAdmissionRequestFromJSON(json: any): CreateMatrixCareHomeHealthAdmissionRequest {
    return CreateMatrixCareHomeHealthAdmissionRequestFromJSONTyped(json, false);
}

export function CreateMatrixCareHomeHealthAdmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMatrixCareHomeHealthAdmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'patient_demo_id': json['patient_demo_id'],
        'source_admission_id': json['source_admission_id'],
        'business_unit_id': json['business_unit_id'],
        'line_of_business_id': json['line_of_business_id'],
        'new_referral_date': json['new_referral_date'],
        'certification_period_start': json['certification_period_start'] == null ? undefined : json['certification_period_start'],
        'copy_flags': MatrixCareAdmissionCopyFlagsFromJSON(json['copy_flags']),
    };
}

export function CreateMatrixCareHomeHealthAdmissionRequestToJSON(json: any): CreateMatrixCareHomeHealthAdmissionRequest {
    return CreateMatrixCareHomeHealthAdmissionRequestToJSONTyped(json, false);
}

export function CreateMatrixCareHomeHealthAdmissionRequestToJSONTyped(value?: CreateMatrixCareHomeHealthAdmissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient_demo_id': value['patient_demo_id'],
        'source_admission_id': value['source_admission_id'],
        'business_unit_id': value['business_unit_id'],
        'line_of_business_id': value['line_of_business_id'],
        'new_referral_date': value['new_referral_date'],
        'certification_period_start': value['certification_period_start'],
        'copy_flags': MatrixCareAdmissionCopyFlagsToJSON(value['copy_flags']),
    };
}

